import { Stack } from '@mui/material';
import { ReactNode } from 'react';
import useWindowDimensions from 'hooks/useWindowDimensions';
type LayoutNoAuthProps = {
  children: ReactNode;
};
export const LayoutNoAuth = ({ children }: LayoutNoAuthProps) => {
  const { height } = useWindowDimensions();
  return (
    <Stack flexDirection={'row'}>
      <Stack flex={1} height={height}>
        {children}
      </Stack>
      <Stack sx={{ display: { xs: 'none', md: 'flex' } }} flex={1}>
        <img
          alt={'bg-auth'}
          width={'100%'}
          height={height}
          style={{ objectFit: 'cover' }}
          src={'/images/layout_no_auth.png'}
        />
      </Stack>
    </Stack>
  );
};
